import axios from "axios";

// Get API URL from runtime config or env
const getApiUrl = () =>
  window.ENV?.REACT_APP_API_URL || process.env.REACT_APP_API_URL || "";

// Get auth service configuration
const getAuthConfig = () => ({
  url:
    window.ENV?.REACT_APP_AUTH_SERVICE_URL ||
    process.env.REACT_APP_AUTH_SERVICE_URL ||
    "https://auth.beilke.com.br/api",
  apiKey:
    window.ENV?.REACT_APP_AUTH_API_KEY ||
    process.env.REACT_APP_AUTH_API_KEY ||
    "",
});

const api = axios.create({
  baseURL: getApiUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor for token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) {
          throw new Error("No refresh token");
        }

        const { url, apiKey } = getAuthConfig();
        const response = await axios.post(
          `${url}/auth/refresh`,
          { refreshToken },
          {
            headers: {
              "Content-Type": "application/json",
              "X-API-Key": apiKey,
            },
          },
        );

        const { accessToken, refreshToken: newRefreshToken } = response.data;
        localStorage.setItem("token", accessToken);
        localStorage.setItem("refreshToken", newRefreshToken);

        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default api;
